import "./pastrymenu.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function PastryMenu() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="foodmenu-container">
        <img
          src="https://i.imgur.com/Evb19ce.jpeg"
          alt=""
          className="food-menu-hero"
        />
        <h1 className="food-menu-header">PASTRIES</h1>
      </div>
      <div className="food-menu-items-container">
        <div className="category">
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Spinach & Feta Borek</h4>
              <p className="item-price">$8.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Ground Beef Borek</h4>
              <p className="item-price">$9.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Butter Croissant</h4>
              <p className="item-price">$4.5</p>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </motion.div>
  );
}

export default PastryMenu;
